export const serviceReminders = [
 "Kostenlose Besichtigung vor Ort",
 "Festpreis-Angebot ohne versteckte Kosten",
 "Schnelle Terminvergabe (meist innerhalb 24h)",
 "Professionelle & diskrete Abwicklung"
]
